import React, {useCallback, useContext} from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {PageTransition} from "@steveeeie/react-page-transition";
import {AppContext} from "../contexts/AppContext";
import {Dashboard} from "./dashboard/Dashboard";
import {Dispatcher} from "./dispatcher/Dispatcher";
import Login from "./common/Login";
import KitchenSelect from "./common/KitchenSelect";
import {isFirefox} from 'react-device-detect';
import {Settings} from "./dispatcher/settings/Settings";
import OrderReady from "./order-ready/OrderReady";
import PartnerSelectionPage from "./common/PartnerSelectionPage";
import {getFromStorage} from "../services/LocalStorage";
import {
  KEY_HAS_ONGOING_ADMIN_LOGIN,
} from "../helpers/Constants";
import {isAdminView} from "../helpers/Util";

export function Routes() {
  const { pages } = useContext(AppContext);
  const hasOngoingAdminLogin = getFromStorage(KEY_HAS_ONGOING_ADMIN_LOGIN);

  return (
      <>
        {/* <Route exact path="/" render={() => <Redirect to="/dashboard" />} /> */}

        <Route
            render={({ location }) => (
                <PageTransition
                    preset={isFirefox ? undefined : "moveToLeftFromRight"}
                    transitionKey={location.pathname}
                    // enterAnimation={animations.moveToLeft}
                    // exitAnimation={animations.moveToLeft}
                >
                  <Switch location={location}>

                    <Route exact path="/login" render={() => <Login showSSOOnly={isAdminView()} />} />
                    <Route exact path="/select-partner"
                           render={() => {
                             return isAdminView() && hasOngoingAdminLogin ? <PartnerSelectionPage />: <Redirect to="/login" showSSOOnly={false} />;
                           }}
                    />
                    <Route exact path="/kitchenselect" render={() => <KitchenSelect />} />
                    <Route exact path="/dashboard" render={() => <Dashboard page={pages[0]} />} />
                    <Route exact path="/dispatcher" render={() => <Dispatcher />} />
                    <Route exact path="/order-ready" render={() => <OrderReady />} />
                    <Route exact path="/dispatcher/login" render={() => <Dispatcher />} />
                    <Route exact path="/dispatcher/settings" render={() => <Settings />} />

                    {pages.map((page, index) => {
                      return (
                          <Route
                              key={index}
                              exact
                              path={'/dashboard/' + page.pageId}
                              render={() => <Dashboard page={page} />}
                          />
                      );
                    })}
                    <Route exact path="/" render={() => <Redirect to="/login" />} />
                    <Route component={Login} />

                  </Switch>
                </PageTransition>
            )}
        />
      </>
  );
}
